// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class PropertySaleStatuses {
    public static readonly SALE: string = 'Sale';
    public static readonly DONATION: string = 'Donation';
}
